/**
 * i18n-fundament (vue-i18n). Engels is de standaardtaal; Nederlands staat
 * ernaast en blijft volledig ondersteund. De actieve taal wordt bepaald
 * door (in volgorde): een expliciete route-locale (marketingpagina's,
 * zodat /nl altijd Nederlands is en /landing altijd Engels voor SEO),
 * daarna de opgeslagen voorkeur, daarna de browsertaal, en anders 'en'.
 *
 * Zie ook stores/locale.ts (persistentie + <html lang>) en de router-guard
 * die per navigatie de juiste taal zet.
 */
import { createI18n } from 'vue-i18n'
import en from './locales/en'
import nl from './locales/nl'

export const SUPPORTED_LOCALES = ['en', 'nl'] as const
export type AppLocale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: AppLocale = 'en'
export const LOCALE_STORAGE_KEY = 'pentrical.locale'

export function isSupportedLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

/** Beste eerste gok: opgeslagen voorkeur → browsertaal → standaard. */
export function resolveInitialLocale(): AppLocale {
  if (typeof window !== 'undefined') {
    const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY)
    if (isSupportedLocale(saved)) return saved
    const nav = window.navigator.language?.slice(0, 2).toLowerCase()
    if (isSupportedLocale(nav)) return nav
  }
  return DEFAULT_LOCALE
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: resolveInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en, nl },
})

export default i18n

/** Buiten componenten (router-guard, stores) de vertaalfunctie gebruiken. */
export const i18nGlobal = i18n.global
